import React from 'react';
import ReactDOM from 'react-dom';

const rootEl = document.getElementById('root');

ReactDOM.render(
  <p>Hello</p>,
  document.getElementById('root'),
);